import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CmdbRegisterPageInfoComponent } from './cmdb-register-page-info.component';

@NgModule({
	declarations: [],
	imports: [CmdbRegisterPageInfoComponent],
	exports: [CmdbRegisterPageInfoComponent],
})
export class CmdbRegisterPageInfoModule {}
